import React, { memo } from "react";
import DriveCard from "../../../components/Cards/DriveCard";
import DriveDocumentCard from "../../../components/Cards/DriveDocumentCard";
import DriveItem from "../../../components/ListItem/DriveItem";
import DriveDocumentItem from "../../../components/ListItem/DriveDocumentItem";

// ✅ PERFORMANCE: Memoize to prevent unnecessary re-renders
const DrivesDocumentsList = memo(({
    drives,
    documents,
    selectMode,
    setShowSlideoutDriveDetail,
    setShowSlideoutDocumentDetail,
    setSelectedDocument,
    viewMode,
    removeAccessToDocument,
    selectedDrives,
    selectedDocuments,
    handleSelectDrive,
    handleSelectDocument,
    removeAccessLoading
}) => {
    console.time('⏱️ DrivesDocumentsList Render');
    console.log('🎨 DrivesDocumentsList: Rendering', drives.length, 'drives and', documents.length, 'documents in', viewMode, 'mode');
    
    const result = (
        viewMode === 'grid' ? (
            <>
                {drives.map((drive) => (
                    <DriveCard
                        key={drive.vaultUuid}
                        {...drive}
                        selectMode={selectMode}
                        onSelect={handleSelectDrive}
                        selectedItems={selectedDrives}
                        setShowSlideoutDriveDetail={setShowSlideoutDriveDetail}
                        removeAccessLoading={removeAccessLoading}
                    />
                ))}
                {documents.map((document) => (
                    <DriveDocumentCard
                        key={document.uuid}
                        {...document}
                        selectMode={selectMode}
                        onSelect={handleSelectDocument}
                        selectedItems={selectedDocuments}
                        setShowSlideoutDocumentDetail={setShowSlideoutDocumentDetail}
                        setSelectedDocument={setSelectedDocument}
                        removeAccessToDocument={removeAccessToDocument}
                        removeAccessLoading={removeAccessLoading}
                    />
                ))}
            </>
        ) : (
            <>
                {drives.map((drive) => (
                    <DriveItem
                        key={drive.vaultUuid}
                        {...drive}
                        selectMode={selectMode}
                        onSelect={handleSelectDrive}
                        selectedItems={selectedDrives}
                        setShowSlideoutDriveDetail={setShowSlideoutDriveDetail}
                        removeAccessLoading={removeAccessLoading}
                    />
                ))}
                {documents.map((document) => (
                    <DriveDocumentItem
                        key={document.uuid}
                        {...document}
                        selectMode={selectMode}
                        onSelect={handleSelectDocument}
                        selectedItems={selectedDocuments}
                        setShowSlideoutDocumentDetail={setShowSlideoutDocumentDetail}
                        setSelectedDocument={setSelectedDocument}
                        removeAccessToDocument={removeAccessToDocument}
                        removeAccessLoading={removeAccessLoading}
                    />
                ))}
            </>
        )
    );
    
    console.timeEnd('⏱️ DrivesDocumentsList Render');
    console.log('✅ DrivesDocumentsList: Render completed');
    return result;
});

DrivesDocumentsList.displayName = 'DrivesDocumentsList';

export default DrivesDocumentsList;
